import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'multiselectSelectedItem',
  pure: true
})
export class MultiselectSelectedItemPipe implements PipeTransform {

  transform(dynField: any, args?: any): any {
    let items: Array<any> = [];
    items = dynField['MultiSelectItemsSelected'];
    let selectedArr: Array<string> = [];
    items.forEach(item => {
      selectedArr.push('"' + item["id"] + '"');
    });
    let selected = selectedArr.join(',');
    return selected;
  }

}
